<ng-container *appTranslate="let t">
  <div [class.pt-4]="!props.readonly" [class]="props.class" [controlRef]="formControl" [fieldConfig]="this">
    @for (tab of field.fieldGroup; track tab) {
      @if (!tab.hide) {
        <p-card [dt]="props.dt?.components?.card">
          <ng-template #title>
            <div class="flex items-center">
              @if (props.formatLabel) {
                <span>
                  @if (isFunction(props.formatLabel)) {
                    {{ props.formatLabel(model, $index) }}
                  } @else if (isString(props.formatLabel)) {
                    {{ evaluateStringExpression(props.formatLabel, model, $index) }}
                  }
                </span>
              }

              @if (props.formatSublabel) {
                <span class="text-text-subtle-text ms-2">
                  @if (isFunction(props.formatSublabel)) {
                    {{ props.formatSublabel(model, $index) }}
                  } @else if (isString(props.formatSublabel)) {
                    {{ evaluateStringExpression(props.formatSublabel, model, $index) }}
                  }
                </span>
              }

              @if (!props.readonly) {
                <div class="row ms-auto">
                  @if (showError && formControl.errors) {
                    <p-tag
                      [dt]="props.dt?.components?.tag"
                      icon="pi pi-exclamation-triangle"
                      severity="danger"
                      [rounded]="true"
                      [pTooltip]="errors"
                    />

                    <ng-template #errors>
                      <formly-validation-message [field]="field" />
                    </ng-template>
                  }

                  <new-ui-button
                    [dt]="props.dt?.components?.button"
                    icon="pi pi-trash"
                    variant="text"
                    severity="danger"
                    [label]="props.removeLabel"
                    [ariaLabel]="props.removeLabel ?? t('common.remove')"
                    [disabled]="!isRemoveEnabled($index)"
                    [removeBtnRef]="formControl"
                    (onClick)="remove($index)"
                  />
                </div>
              }
            </div>
          </ng-template>

          <formly-field [field]="tab" />
        </p-card>
      }
    } @empty {
      @if (props.emptystate) {
        <ui-emptystate
          [dt]="props.dt?.components?.emptystate"
          class="py-[3%]"
          [image]="props.emptystate.image"
          [caption]="props.emptystate.caption"
          [description]="props.emptystate.description"
        />
      }
    }

    @if (!props.readonly) {
      <div class="row border-t-1 border-surface-border pt-4">
        <new-ui-button
          [dt]="props.dt?.components?.button"
          icon="icon-[mi--plus-medium]"
          [label]="props.addLabel"
          [ariaLabel]="props.addLabel"
          [disabled]="!isAddEnabled"
          [addBtnRef]="formControl"
          (onClick)="add(null, props.defaultValue?.())"
        />

        @if (uploadMenu?.length) {
          @if (uploadMenu.length > 1) {
            <new-ui-button
              [dt]="props.dt?.components?.button"
              icon="icon-[mi--document-file-upload-bottom-center]"
              severity="secondary"
              [label]="props.uploadLabel"
              [ariaLabel]="props.uploadLabel"
              (onClick)="menu.toggle($event)"
            />

            <p-menu #menu [popup]="true" [model]="uploadMenu" [dt]="props.dt?.components?.menu" appendTo="body" />
          } @else {
            <new-ui-button
              [dt]="props.dt?.components?.button"
              icon="icon-[mi--document-file-upload-bottom-center]"
              severity="secondary"
              [label]="props.uploadLabel"
              [ariaLabel]="props.uploadLabel"
              (onClick)="openUploadDialog(props.uploadTypes[0])"
            />
          }
        }
      </div>
    }
  </div>
</ng-container>
